import { useQuery } from "@tanstack/react-query";
import { getUrl } from "../App";

async function getSession() {
  const response = await fetch(`${getUrl()}/_allauth/browser/v1/auth/session`, {
    credentials: "include",
  });

  // 1. Handle "Not Logged In" statuses as successful data returns
  if (response.status === 401 || response.status === 410) {
    return { isAuthenticated: false };
  }

  // 2. Handle actual server errors (500, etc)
  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(JSON.stringify(errorData));
  }

  // 3. Handle success
  const responseData = await response.json();
  return { isAuthenticated: responseData.meta.is_authenticated };
}

export function useAuthSessionQuery() {
  return useQuery({
    queryKey: ["authSession"],
    queryFn: () => getSession(),
    retry: false,
  });
}
